/* Blok & Blaauw: gedeelde code voor elke pagina met de gewone layout.
   Header-rand bij scrollen, burgermenu, het Diensten-menu, de headerknop op dienstpagina's, de pauzeknop van de strip,
   reveal (.rv -> .in) en het jaartal in de footer.
   Robuust als elementen ontbreken, en werkt opnieuw na het herladen van een sectie in de thema-editor.
   Alles staat in een IIFE, zodat const-namen uit sectiescripts (hdr, burger, io) niet botsen. */
(function () {
  'use strict';

  function $(id) { return document.getElementById(id); }

  /* Header: rand zodra er gescrold is */
  function onScroll() {
    var hdr = $('hdr');
    if (hdr) hdr.classList.toggle('scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Diensten-menu (details.nav-grp): dicht bij een klik erbuiten, bij Escape en bij het sluiten van het burgermenu */
  function groups() { return document.querySelectorAll('details.nav-grp[open]'); }
  function closeGroups(except) {
    Array.prototype.forEach.call(groups(), function (d) { if (d !== except) d.open = false; });
  }

  /* Burgermenu */
  function setOpen(open) {
    var hdr = $('hdr'), burger = $('burger');
    if (!hdr) return;
    hdr.classList.toggle('open', open);
    if (!open) closeGroups();
    if (burger) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
    }
  }
  function isOpen() { var hdr = $('hdr'); return !!(hdr && hdr.classList.contains('open')); }
  function closest(e, sel) { return e.target && e.target.closest ? e.target.closest(sel) : null; }

  /* Stand vóór de klik vastleggen (capture). Schakelt een ander script het menu al om,
     dan nemen we die stand over in plaats van hem terug te draaien. */
  var before = null;
  document.addEventListener('click', function (e) {
    before = closest(e, '#burger') ? isOpen() : null;
    /* Tik buiten de header sluit het open menu, en doet verder niets: zo opent
       een tik om het menu weg te halen niet per ongeluk een link of knop eronder.
       De cookiemelding van Shopify blijft gewoon klikbaar. */
    if (isOpen() && !closest(e, '#hdr') && !closest(e, '#shopify-pc__banner, #shopify-pc__prefs')) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(false);
    }
  }, true);
  document.addEventListener('click', function (e) {
    if (closest(e, '#burger')) {
      var now = isOpen();
      setOpen(before !== null && now !== before ? now : !now);
      before = null;
      return;
    }
    if (closest(e, '#nav a')) setOpen(false);
  });
  /* Klik buiten het Diensten-paneel sluit het; een klik op een link erin ook (op home blijft de pagina anders staan).
     Een klik op de summary zelf opent en sluit alleen het paneel, niet het burgermenu. */
  document.addEventListener('click', function (e) {
    var d = closest(e, 'details.nav-grp');
    closeGroups(d && !closest(e, '.nav-sub a') ? d : null);
  });
  /* Escape: eerst het Diensten-paneel, daarna het burgermenu */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = groups()[0];
    if (open) {
      open.open = false;
      var s = open.querySelector('summary');
      if (s) s.focus();
      return;
    }
    if (isOpen()) {
      setOpen(false);
      var burger = $('burger');
      if (burger) burger.focus();
    }
  });
  /* Focus buiten de header sluit het burgermenu (Tab na de laatste menulink, Shift+Tab naar de skiplink).
     Op desktop sluit het Diensten-paneel als de focus het paneel verlaat, anders blijft het over de pagina hangen. */
  var wide = window.matchMedia ? window.matchMedia('(min-width: 1081px)') : null;
  document.addEventListener('focusin', function (e) {
    if (isOpen() && !closest(e, '#hdr')) setOpen(false);
    if (wide && wide.matches) closeGroups(closest(e, 'details.nav-grp'));
  });

  /* Headerknop op dienstpagina's (.pd-hero): dezelfde link als de knop in de hero, zodat het formulier de wens
     (en de branche) al weet. Alleen daar: op home en elders blijft het gewoon #contact. */
  function ctaContext() {
    var src = document.querySelector('.pd-hero a[href*="?wens="][href*="#contact"], .pd-hero a[href*="?branche="][href*="#contact"]');
    if (!src) return;
    var href = src.getAttribute('href');
    Array.prototype.forEach.call(document.querySelectorAll('.hdr-cta, #nav a.btn-primary'), function (a) { a.setAttribute('href', href); });
  }
  ctaContext();

  /* Pauzeknop van de strip op home (WCAG 2.2.2): zet .is-paused op .strip */
  document.addEventListener('click', function (e) {
    var b = closest(e, '.strip-pause');
    if (!b) return;
    var strip = b.closest('.strip');
    if (!strip) return;
    var paused = !strip.classList.contains('is-paused');
    strip.classList.toggle('is-paused', paused);
    b.setAttribute('aria-pressed', paused ? 'true' : 'false');
  });

  /* Jaartal */
  function year() {
    var yr = $('yr');
    if (yr) yr.textContent = new Date().getFullYear();
  }
  year();

  /* Reveal: .rv krijgt .in zodra het in beeld komt */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function reveal(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.rv:not(.in)'), function (el) {
      if (io) io.observe(el); else el.classList.add('in');
    });
  }
  reveal();

  /* Bedragen met data-count tellen op zodra ze in beeld komen (700 ms). De echte tekst staat al in de HTML,
     dus zonder JavaScript of met minder beweging zie je gewoon het bedrag. */
  (function () {
    var els = document.querySelectorAll('[data-count]');
    if (!els.length || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var fmt = function (n) { return '\u20AC' + n.toLocaleString('nl-NL'); };
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        co.unobserve(en.target);
        var el = en.target, to = parseInt(el.getAttribute('data-count'), 10), t0 = null;
        if (!to) return;
        var step = function (t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / 700), e = 1 - Math.pow(1 - k, 3);
          el.textContent = fmt(Math.round(to * e));
          if (k < 1) requestAnimationFrame(step); else el.textContent = fmt(to);
        };
        requestAnimationFrame(step);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    Array.prototype.forEach.call(els, function (el) { co.observe(el); });
  })();
  /* Voor secties die later nog .rv-elementen toevoegen */
  window.bbReveal = reveal;

  /* Cookie-instellingen: de link in de footer verschijnt alleen als Shopify's privacybanner actief is */
  function privacy() { var pb = window.privacyBanner; return pb && typeof pb.showPreferences === 'function' ? pb : null; }
  function consentLinks() {
    if (!privacy()) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-consent-link]'), function (a) { a.hidden = false; });
  }
  document.addEventListener('click', function (e) {
    if (!closest(e, '[data-consent-link]')) return;
    e.preventDefault();
    var pb = privacy();
    if (pb) pb.showPreferences();
  });
  if (document.readyState === 'complete') consentLinks(); else window.addEventListener('load', consentLinks);

  /* Thema-editor: na het herladen van een sectie alles opnieuw koppelen */
  document.addEventListener('shopify:section:load', function (e) {
    reveal(e.target);
    onScroll();
    year();
    consentLinks();
    ctaContext();
  });
})();
